import useFlag from 'lane-shared/hooks/useFlag';

import { FeatureFlag } from 'constants-flags';

export function useInspectionsTemplateLibraryEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.InspectionsTemplateLibrary,
    false
  );

  return Boolean(isEnabled);
}
